var _defs, _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconPatientProtection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.25 9.937A13.5 13.5 0 0 1 12 23.25 13.5 13.5 0 0 1 .75 9.937V2.25a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 18.697,
    cy: 10.089,
    r: 1.869
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.75 14.29a3.855 3.855 0 0 0-5.306-.767"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.31,
    cy: 10.089,
    r: 1.869
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.257 14.289a3.856 3.856 0 0 1 5.306-.767m8.656 2.486a4.342 4.342 0 1 0-8.683 0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 11.833,
    cy: 7.916,
    r: 2.566
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconPatientProtection);
export default __webpack_public_path__ + "static/media/streamline-icon-patient-protection.dca283d0.svg";
export { ForwardRef as ReactComponent };